import script from "./SignalDetail.vue?vue&type=script&setup=true&lang=js"
export * from "./SignalDetail.vue?vue&type=script&setup=true&lang=js"

import "./SignalDetail.vue?vue&type=style&index=0&id=31ae8026&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-31ae8026"]])

export default __exports__